import type { CaptureMethod } from '@bower/shared';

import { performResumableUpload, type PerformUploadResult } from './performUpload';

export interface RecordedAudioUploadArgs {
  readonly workspaceId: string;
  readonly parentEntityType: string;
  readonly parentEntityId: string;
  readonly title?: string;
  readonly importAsNotes: boolean;
  readonly captureMethod?: CaptureMethod;
  // No `captureSurface`: a voice recording is never an onboarding import, and
  // its device is the `x-bower-client` header the request already carries.
  readonly multipleSpeakers: boolean;
  /** Server-owned transcription cutover (see PerformUploadArgs). */
  readonly serverTranscription?: boolean;
  readonly durationMs: number;
  /** Finalize-only retry handle from an ambiguous prior response. */
  readonly resumeFinalizeUploadId?: string;
}

/**
 * The shared byte-transfer boundary for a completed voice recording. It returns
 * only after reserve, direct-to-GCS transfer, and server-side finalization have
 * succeeded; transcription remains owned by the caller's existing workflow.
 */
export function uploadRecordedAudio(
  file: File,
  args: RecordedAudioUploadArgs,
  onProgress?: (pct: number) => void,
  signal?: AbortSignal,
): Promise<PerformUploadResult> {
  return performResumableUpload(
    file,
    { ...args, voiceRecordingDurationMs: args.durationMs },
    onProgress,
    signal,
  );
}
